import {
  CurrencyValue,
  LineChart,
  formatNumber,
  BarChart
} from '@blockanalitica/ui';
import {
  SimpleChartData,
  SimpleChartDataset
} from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';
import { useChartFillDatasetsDates } from '@/hooks';
import { useCallback } from 'react';
import { useTheme } from 'styled-components';

export default function HistoricGraphs({
  data,
  type,
  chartDaysAgo
}: {
  data: SimpleChartData[];
  type: string;
  chartDaysAgo: string;
}) {
  const theme = useTheme();

  const yScaleValueFormatter = useCallback((value: string | number) => {
    return `${formatNumber(Number(value))}`;
  }, []);

  const valueFormatter = useCallback((value: string | number) => {
    return (
      <CurrencyValue
        value={value}
        variant="dynamic"
        options={{ notation: 'standard' }}
      />
    );
  }, []);
  const datasets: SimpleChartDataset[] =
    type === 'total_new_wallets'
      ? [
          {
            xField: 'date',
            yField: type,
            backgroundColor: theme.colors.primary
          }
        ]
      : [
          {
            xField: 'date',
            yField: type
          }
        ];
  const chartData = useChartFillDatasetsDates(data, datasets, chartDaysAgo);

  return type === 'total_new_wallets' ? (
    <BarChart
      key={type}
      data={chartData}
      datasets={datasets}
      valueFormatter={valueFormatter}
      yScaleValueFormatter={yScaleValueFormatter}
      daysAgo={chartDaysAgo}
    />
  ) : (
    <LineChart
      key={type}
      data={chartData}
      datasets={datasets}
      valueFormatter={valueFormatter}
      yScaleValueFormatter={yScaleValueFormatter}
      daysAgo={chartDaysAgo}
    />
  );
}
